import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import AgeVerification from './components/AgeVerification';
import CookiePopup from './components/CookiePopup';
import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import OfferReview from './pages/OfferReview';
import Comparison from './pages/Comparison';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-dark-bg">
          <AgeVerification />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/offers/:id" element={<OfferReview />} />
            <Route path="/comparison" element={<Comparison />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
          <Footer />
          <CookiePopup />
          <BackToTop />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
